import { CardAppIcon } from "../CardAppIcon/CardAppIcon";
import { Button } from "../../../../Components";
import styles from "./CreateTileCard.module.less";
import { ReactElement, useCallback } from "react";
import { categoryToNameMap } from "../CategoryFilter";
import { appKindToNameMap } from "../AppCard";
import { localize } from "client_legacy/ndaw/culture";
import { setTrackingId } from "client/Misc/utils";
import { AvailableAppModel } from "client/Api/Workspace/workspace";

export type CreateTileCardProps = {
	tile: AvailableAppModel;
	onClick: (appId: number) => void;
	trackingId?: string;
};

export const CreateTileCard = (props: CreateTileCardProps): ReactElement => {
	const {
		onClick,
		tile,
		trackingId
	} = props;

	const categoryName: LocalizationKey = categoryToNameMap[tile.appCategory];
	const typeName: string = appKindToNameMap[tile.appType];

	const handleClick = useCallback(
		(): void => {
			onClick(tile.installedAppId);
		},
		[onClick, tile]
	);

	return (
		<div
			{...setTrackingId(trackingId)}
			className={styles.root}>
			<div className={styles.iconContainer}>
				<CardAppIcon appColor={tile.color} icon={tile.image} />
			</div>
			<h4
				{...setTrackingId("name")}
				className={styles.name}
				title={tile.name}
			>
				{tile.name}
			</h4>
			<p
				{...setTrackingId("type-name")}
				className={styles.info}
			>
				{typeName}
			</p>
			<p
				{...setTrackingId("category-name")}
				className={styles.info}
			>
				{localize(categoryName)}
			</p>
			<div className={styles.buttonContainer}>
				<Button
					trackingId="create"
					kind="primary"
					text={localize("_Create")}
					width="fill"
					onClick={handleClick}
				/>
			</div>
		</div>
	);
};

CreateTileCard.displayName = "CreateTileCard";
